import { render, staticRenderFns } from "./ReinspectionTask.vue?vue&type=template&id=10f619b0&scoped=true&"
import script from "./ReinspectionTask.vue?vue&type=script&lang=js&"
export * from "./ReinspectionTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f619b0",
  null
  
)

export default component.exports